const state = {
  namespaced: true,
  state: {
    filterBasis: [], // 筛选出的poi类型
    filterLabels: { topLabel: '', leftLabel: '' }, // places筛选组件的label
  },
  mutations: {
    SET_FILTER_BASIS(state, typeList) {
      state.filterBasis = typeList
    },
    SET_FILTER_LABELS(state, labels) {
      state.filterLabels = {
        topLabel: labels.topLabel,
        leftLabel: labels.leftLabel
      }
    }
  },
  actions: {
    setFilterBasis({ commit }, typeList) {
      commit('SET_FILTER_BASIS', typeList)
    },
    setFilterLabels({ commit }, labels) {
      commit('SET_FILTER_LABELS', labels)
    }
  }
}

export default state
